
export default function MinistriesSection() {
  const ministries = [
    {
      number: '01',
      icon: 'ri-video-line',
      title: '선교지 리포팅 & 미디어 사역',
      subtitle: 'Field Reporting & Media',
      tagline: '보이지 않는 선교 현장을 보이게 만듭니다',
      features: [
        {
          icon: 'ri-camera-line',
          title: '현장 탐방 및 콘텐츠 제작',
          description: '킹덤브릿지가 직접 선교지를 방문하여 선교사님의 삶과 사역 현장을 영상과 인터뷰로 담아냅니다.'
        },
        {
          icon: 'ri-notification-line',
          title: '긴급 기도 제목 공유',
          description: '텍스트로만 전달되던 기도 편지를 넘어, 현장의 급박한 필요와 상황을 생생하게 알립니다.'
        },
        {
          icon: 'ri-search-line',
          title: '숨겨진 선교지 발굴',
          description: '잘 알려지지 않아 후원의 사각지대에 있는 오지 선교지와 사역자들을 발굴하여 연결합니다.'
        }
      ]
    },
    {
      number: '02',
      icon: 'ri-heart-pulse-line',
      title: '선교사 멤버 케어 & 전략적 후원',
      subtitle: 'Member Care & Strategic Support',
      tagline: '선교사가 살아야 선교지가 살아납니다',
      features: [
        {
          icon: 'ri-hand-heart-line',
          title: '선교사 재충전 및 위로',
          description: '번아웃된 선교사님들이 영적, 육체적 쉼을 얻을 수 있도록 방문하여 위로하고 격려합니다.'
        },
        {
          icon: 'ri-funds-line',
          title: '프로젝트 기반 후원',
          description: '우물 파기, 건축, 구제 등 선교지의 구체적인 필요에 맞는 목적형 후원 프로젝트를 기획합니다.'
        },
        {
          icon: 'ri-rocket-line',
          title: '동원 및 파송 지원',
          description: '선교 동원과 훈련에 필요한 자원을 공급하며 후방에서 든든한 보급 기지가 됩니다.'
        }
      ]
    },
    {
      number: '03',
      icon: 'ri-book-open-line',
      title: '글로벌 신학 교육',
      subtitle: 'Global Education Ministry',
      tagline: '현지 지도자를 세워 자립을 돕습니다',
      features: [
        {
          icon: 'ri-school-line',
          title: '현지 신학교 운영 지원',
          description: '선교지에 신학교 커리큘럼을 제공하고 강의하여, 현지인 목회자가 스스로 교회를 세울 수 있도록 돕습니다.'
        },
        {
          icon: 'ri-computer-line',
          title: '온라인 신학 강좌',
          description: '지리적 한계를 넘어 양질의 신학 교육을 받을 수 있도록 온라인 강의 시스템을 구축합니다.'
        }
      ]
    },
    {
      number: '04',
      icon: 'ri-church-line',
      title: '미자립교회 협력 및 지원',
      subtitle: 'Church Partnership & Support',
      tagline: '작은 교회가 든든히 서도록 함께 걷습니다',
      features: [
        {
          icon: 'ri-community-line',
          title: '교회 네트워킹',
          description: '재정적, 인적 자원이 부족한 미자립교회들을 발굴하고 연결하여 협력 네트워크를 구축합니다.'
        },
        {
          icon: 'ri-gift-line',
          title: '사역 자원 지원',
          description: '예배 및 교육 자료, 시설 개선, 목회자 훈련 등 실질적인 필요를 파악하고 맞춤형 지원을 제공합니다.'
        },
        {
          icon: 'ri-team-line',
          title: '선교 동역 연결',
          description: '미자립교회가 선교 비전을 품고 실천할 수 있도록 선교지와 연결합니다.'
        }
      ]
    },
    {
      number: '05',
      icon: 'ri-flashlight-line',
      title: '영적 발전소',
      subtitle: 'Spiritual Power Station',
      tagline: '사역의 동력을 공급하는 기도의 힘',
      features: [
        {
          icon: 'ri-calendar-check-line',
          title: '수요 삶의 기도',
          description: '매주 수요일, 선교지와 후원자들이 온라인으로 연결되어 열방을 향해 중보합니다.'
        },
        {
          icon: 'ri-group-line',
          title: '예배와 연합',
          description: '정기 모임과 예배를 통해 사역의 본질을 확인하고, 거룩한 연대를 이룹니다.'
        }
      ]
    }
  ];

  return (
    <section id="ministries" className="py-12 sm:py-16 md:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        {/* Header */}
        <div className="text-center mb-10 sm:mb-16">
          <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 mb-3 sm:mb-4">
            KBM 주요 사역
          </h2>
          <p className="text-sm sm:text-base md:text-lg text-teal-600 font-semibold">Our Ministries</p>
        </div>

        {/* Ministries List */}
        <div className="space-y-8 sm:space-y-12 md:space-y-16">
          {ministries.map((ministry, index) => (
            <div 
              key={index}
              className="bg-gradient-to-br from-gray-50 to-white rounded-2xl sm:rounded-3xl p-5 sm:p-8 md:p-12 shadow-lg"
            >
              {/* Ministry Header */}
              <div className="flex flex-col sm:flex-row sm:items-start gap-4 sm:gap-6 mb-6 sm:mb-8">
                <div className="flex items-center sm:block gap-4 sm:gap-0">
                  <div className="w-14 h-14 sm:w-16 sm:h-16 md:w-20 md:h-20 bg-teal-100 rounded-xl sm:rounded-2xl flex items-center justify-center flex-shrink-0">
                    <i className={`${ministry.icon} text-2xl sm:text-3xl md:text-4xl text-teal-600`}></i>
                  </div>
                  <div className="sm:hidden text-sm font-bold text-teal-600">{ministry.number}</div>
                </div>
                <div className="flex-1">
                  <div className="hidden sm:block text-sm font-bold text-teal-600 mb-2">{ministry.number}</div>
                  <h3 className="text-lg sm:text-xl md:text-2xl lg:text-3xl font-bold text-gray-900 mb-1 sm:mb-2">
                    {ministry.title}
                  </h3>
                  <p className="text-xs sm:text-sm font-semibold text-teal-600 mb-2 sm:mb-3">
                    {ministry.subtitle}
                  </p>
                  <p className="text-sm sm:text-base md:text-lg font-semibold text-gray-700 italic">
                    "{ministry.tagline}"
                  </p>
                </div>
              </div>

              {/* Features Grid */}
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 sm:gap-4 md:gap-6">
                {ministry.features.map((feature, featureIndex) => (
                  <div 
                    key={featureIndex}
                    className="bg-white rounded-lg sm:rounded-xl p-4 sm:p-5 md:p-6 shadow-md"
                  >
                    <div className="w-10 h-10 sm:w-12 sm:h-12 bg-teal-50 rounded-lg flex items-center justify-center mb-3 sm:mb-4">
                      <i className={`${feature.icon} text-lg sm:text-xl md:text-2xl text-teal-600`}></i>
                    </div>
                    <h4 className="text-sm sm:text-base font-bold text-gray-900 mb-2 sm:mb-3">
                      {feature.title}
                    </h4>
                    <p className="text-xs sm:text-sm text-gray-600 leading-relaxed">
                      {feature.description}
                    </p>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>

        {/* Bottom Image Gallery - Hidden on mobile for cleaner look */}
        <div className="hidden sm:grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4 sm:gap-6 mt-10 sm:mt-16">
          <div className="relative h-48 sm:h-56 md:h-72 rounded-xl sm:rounded-2xl overflow-hidden shadow-lg">
            <img 
              src="https://public.readdy.ai/ai/img_res/109b062f0f47fe93021b6e54597cd516.jpg"
              alt="선교지 리포팅 & 미디어 사역"
              className="w-full h-full object-cover object-top"
            />
          </div>
          <div className="relative h-48 sm:h-56 md:h-72 rounded-xl sm:rounded-2xl overflow-hidden shadow-lg">
            <img 
              src="https://readdy.ai/api/search-image?query=compassionate%20care%20for%20exhausted%20missionary%20showing%20emotional%20support%20and%20encouragement%2C%20warm%20embrace%20or%20comforting%20conversation%20scene%2C%20soft%20golden%20lighting%20conveying%20hope%20and%20restoration%2C%20authentic%20photography%20capturing%20member%20care%20ministry%20and%20spiritual%20renewal%20through%20personal%20connection%20and%20prayer%20support&width=600&height=800&seq=ministry-member-care&orientation=portrait"
              alt="선교사 멤버 케어 & 전략적 후원"
              className="w-full h-full object-cover object-top"
            />
          </div>
          <div className="relative h-48 sm:h-56 md:h-72 rounded-xl sm:rounded-2xl overflow-hidden shadow-lg">
            <img 
              src="https://readdy.ai/api/search-image?query=local%20indigenous%20students%20studying%20theology%20in%20simple%20classroom%20setting%20with%20open%20bibles%20and%20notebooks%2C%20dedicated%20teacher%20instructing%20future%20church%20leaders%2C%20natural%20lighting%20showing%20educational%20ministry%20empowering%20native%20pastors%2C%20documentary%20style%20photography%20emphasizing%20theological%20training%20and%20leadership%20development%20for%20self-sustaining%20local%20churches&width=600&height=800&seq=ministry-education&orientation=portrait"
              alt="글로벌 신학 교육"
              className="w-full h-full object-cover object-top"
            />
          </div>
          <div className="relative h-48 sm:h-56 md:h-72 rounded-xl sm:rounded-2xl overflow-hidden shadow-lg hidden md:block">
            <img 
              src="https://readdy.ai/api/search-image?query=small%20rural%20church%20building%20with%20humble%20architecture%20showing%20community%20gathering%2C%20pastor%20welcoming%20congregation%20members%20with%20warm%20smiles%2C%20simple%20interior%20with%20wooden%20pews%20and%20cross%2C%20natural%20daylight%20streaming%20through%20windows%20creating%20hopeful%20atmosphere%2C%20documentary%20photography%20style%20capturing%20partnership%20ministry%20supporting%20under-resourced%20churches%20with%20dignity%20and%20respect%20for%20local%20faith%20communities&width=600&height=800&seq=ministry-church-support&orientation=portrait"
              alt="미자립교회 협력 및 지원"
              className="w-full h-full object-cover object-top"
            />
          </div>
          <div className="relative h-48 sm:h-56 md:h-72 rounded-xl sm:rounded-2xl overflow-hidden shadow-lg hidden lg:block">
            <img 
              src="https://readdy.ai/api/search-image?query=diverse%20group%20of%20believers%20praying%20together%20online%20through%20video%20call%20screens%20showing%20united%20intercession%2C%20multiple%20faces%20on%20computer%20monitors%20joined%20in%20prayer%20for%20nations%2C%20warm%20lighting%20creating%20atmosphere%20of%20spiritual%20power%20and%20connection%2C%20modern%20photography%20style%20capturing%20digital%20prayer%20meeting%20and%20worship%20unity%20across%20distances%20for%20global%20mission%20support&width=600&height=800&seq=ministry-prayer-power&orientation=portrait"
              alt="영적 발전소"
              className="w-full h-full object-cover object-top"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
